import { connect } from "react-redux";
import BrokerDealsContainer from "./BrokerDealsContainer";
import CorporateDataDealsContainer from "./CorporateDataDealsContainer";
import DataAdminDealsContainer from "./DataAdminDealsContainer";

const DealsContainer = (props) => {
    const { role, user } = props;
    switch (role) {
        case "broker": {
            return <BrokerDealsContainer user={user} role={role} />;
        }
        case "debtEquity": {
            return <BrokerDealsContainer user={user} role={role} />;
        }
        case "evp": {
            return <BrokerDealsContainer user={user} role={role} />;
        }
        case "portlandBrokerAdmin": {
            return <BrokerDealsContainer user={user} role={role} />;
        }
        case "arizonaBrokerAdmin": {
            return <BrokerDealsContainer user={user} role={role} />;
        }
        case "dataEntry": {
            return <CorporateDataDealsContainer user={user} />;
        }
        case "dataAdmin": {
            return <DataAdminDealsContainer user={user} />;
        }
        default: {
            return null;
        }
    }
};

const mapStateToProps = (state) => {
    return {
        role: state.authReducer.userProfile.role,
        user: state.authReducer.userProfile.user,
    };
};

export default connect(mapStateToProps)(DealsContainer);
